<template>
  <div id="app">
    <keep-alive>
      <router-view/>
    </keep-alive>
  </div>
</template>

<script>

export default {
  name: 'App',
  computed:{
    key(){
      return this.$route.path + Math.random();
    }
  }
}
</script>

<style lang="less" scoped>
// 公共样式
</style>
